"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = redirect;

function redirect(to) {
  if (window.location.search.indexOf('noredirect') === -1) {
    window.location.replace(to);
  } else {
    console.log("Would have redirected to " + to); // eslint-disable-line no-console
  }
}

module.exports = exports.default;